// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logout-popup[data-v-4d60374e]{font-weight:700}.footer-wrapper[data-v-4d60374e]{border:1px solid #fff}.link-to-other-platform[data-v-4d60374e]{color:#fff!important;font-size:14px;padding-bottom:2px;text-decoration:none}.link-container[data-v-4d60374e]{padding:10px;border-radius:4px}.link-container[data-v-4d60374e]:hover{background:hsla(0,0%,100%,.096)!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
